export default class Command {
    constructor() {
        this.startDate = ''
        this.endDate = ''
    }
}